import { render, staticRenderFns } from "./PasswordResetConfirmationForm.vue?vue&type=template&id=500e5813&scoped=true&"
import script from "./PasswordResetConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetConfirmationForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetConfirmationForm.vue?vue&type=style&index=0&id=500e5813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e5813",
  null
  
)

export default component.exports